/*
 * @Author: Claude
 * @Date: 2026-03-11
 * @Description: SEO sections entry file for AI Twin Generator page
 */
import React from 'react';

import ComparisonSection from './ComparisonSection';
import CTASection from './CTASection';
import ExploreToolsSection from './ExploreToolsSection';
import FAQSection from './FAQSection';
import FeaturesSection from './FeaturesSection';
import HeroSection from './HeroSection';
import HeroSupportingSection from './HeroSupportingSection';
import HowToUseSection from './HowToUseSection';
import TestimonialsSection from './TestimonialsSection';
import WhyChooseSection from './WhyChooseSection';

const SEOSections: React.FC = () => {
  return (
    <>
      <HeroSection />
      <HeroSupportingSection />
      <HowToUseSection />
      <FeaturesSection />
      <WhyChooseSection />
      <ComparisonSection />
      <TestimonialsSection />
      <ExploreToolsSection />
      <FAQSection />
      <CTASection />
    </>
  );
};

export default SEOSections;
